<template>
    <modal close-button-text="Ok, got it">
        <div slot="header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
            <i class="icons8-info"/>
        </div>
        <div slot="body">
            <strong>This red dotted line is the boundary for the London Congestion Charge Zone.</strong><br>
            <p>The Congestion Charge is a £15 daily charge if you drive within the Congestion Charge zone 07:00 - 18:00 Monday - Friday, and 12:00 - 18:00 Saturday - Sunday, and bank holidays. No charge between Christmas Day and New Year's Day bank holiday (inclusive).</p>
            <p>In addition, there’s a £12.50 charge per day for those vehicles that don’t meet the Ultra Low Emission Zone (ULEZ) standard. The Ultra Low Emission Zone (ULEZ) operates 24 hours a day, 7 days a week, every day of the year, except Christmas Day.</p>
            <h6><i>Powered by TfL open data. Contains QS data © Crown copyright and database rights 2022</i></h6>
        </div>
    </modal>
</template>

<script>
    import Modal from '../Modal';
    import ModalBase from '../ModalBase';

    export default {
        name: 'congestion-modal',

        components: { Modal },

        mixins: [ModalBase],

        mounted() {
            window.bus.$on('showCongestionModal', this.showModal);
        },
    }
</script>

<style lang="less">
    @import "../../../less/variables";

    #congestion-modal {
        .modal-dialog {
            max-width: 580px;
            text-align: center;
            font-family: @headings-font-family;
            font-size: 16px;
            font-weight: 400;
            line-height: 26px;
        }
        .modal-header {
            color: @YPS-secondary;
            font-size: 35px;
            @media (min-width: @screen-sm-min) {
                padding-top: 42px;
            }
        }
        .modal-body {
            @media (min-width: @screen-sm-min) {
                padding: 6px 45px;
            }
            p {
                margin: 12px 0 0 0;
            }
        }
        .modal-footer {
            text-align: center;
            @media (min-width: @screen-sm-min) {
                padding-bottom: 42px;
            }
            button {
                display: inline-block;
                font-family: inherit;
                font-size: .875em;
                font-weight: 700;
                padding: 11px 24px;
            }
        }
    }
</style>
